import { SALES_CHANNEL_CATEGORY_GROUP_DETAIL_TABS } from "@/features/sales-channel-category-group/components/SalesChannelCategoryGroupDetail";
import { SalesChannelCategoryGroupDetailPage } from "@/features/sales-channel-category-group/pages/SalesChannelCategoryGroupDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute(
	"/admin/sales-channel-category-group/$id/detail",
)({
	validateSearch: z.object({
		// Optional so every existing link to this page keeps working untouched.
		tab: z
			.enum(SALES_CHANNEL_CATEGORY_GROUP_DETAIL_TABS)
			.optional()
			.catch(undefined),
	}),
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["sales_channel_category_groups.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCategoryGroupDetailPage,
});
